import { motion, AnimatePresence } from "framer-motion";
import { SurveyingIcon } from "./Icons";
import TiltableImage from "./TiltableImage";

export const PreviewPanel = ({ item, theme = "blue", layout = "split" }) => {
  const themeStyles = {
    blue: { title: "text-blue-600" },
    green: { title: "text-green-700" },
  };
  const styles = themeStyles[theme];
  const isSplit = layout === "split";

  const containerClasses = isSplit
    ? "bg-white/80 backdrop-blur-lg rounded-2xl border border-white/50 p-6 shadow-2xl shadow-slate-500/10 lg:sticky top-32"
    : "bg-transparent p-0 shadow-none grid grid-cols-1 lg:grid-cols-5 gap-8 items-center";

  return (
    <aside className={`w-full h-full flex flex-col ${containerClasses}`}>
      <AnimatePresence mode="wait">
        {!item ? (
          <motion.div
            key="empty"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="flex flex-col items-center justify-center text-center h-full text-gray-500"
          >
            <SurveyingIcon />
            <p className="mt-2 font-medium">
              Select an item to see the details.
            </p>
          </motion.div>
        ) : (
          <motion.div
            key={item.id}
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={{ visible: { transition: { staggerChildren: 0.1 } } }}
            className={isSplit ? "flex flex-col flex-grow" : "contents"}
          >
            <motion.div
              variants={{
                hidden: { opacity: 0, scale: 0.95 },
                visible: {
                  opacity: 1,
                  scale: 1,
                  transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] },
                },
              }}
              style={{ perspective: "1000px" }}
              className={
                isSplit
                  ? "w-full h-56 2xl:h-64"
                  : "w-full h-80 md:h-[450px] lg:col-span-3"
              }
            >
              <TiltableImage src={item.img} alt={item.title} />
            </motion.div>
            <div
              className={`flex flex-col flex-grow ${
                isSplit
                  ? "mt-4"
                  : "lg:col-span-2 bg-white/80 backdrop-blur-lg rounded-2xl p-6 md:p-8 lg:-ml-16 z-10"
              }`}
            >
              <motion.h3
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  visible: {
                    opacity: 1,
                    y: 0,
                    transition: { duration: 0.4, ease: "easeOut" },
                  },
                }}
                className={`text-2xl md:text-3xl font-bold ${styles.title}`}
              >
                {item.title}
              </motion.h3>
              <motion.p
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  visible: {
                    opacity: 1,
                    y: 0,
                    transition: { duration: 0.4, ease: "easeOut", delay: 0.1 },
                  },
                }}
                className="text-gray-600 mt-3 leading-relaxed flex-grow"
              >
                {item.details}
              </motion.p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </aside>
  );
};
